import type { APITypes } from '../../../../primary-record-types';
import { getIntl } from '../../../../utils/intl';
import { noteCategoryTagMessages, resourceCategoryMessages } from '../../../../utils/sharedMessages';
import { ChipSetChip } from '../../../v2BaseComponents/Chip';

const intl = getIntl('note-tag-list', {
    medications: 'Medications',
    allergies: 'Allergies',
    conditions: 'Conditions',
    visits: 'Visits',
    profile: 'Profile',
    user: 'User Note',
    careTeamMember: 'Care Team',
});

export default function getNoteTags(
    note: APITypes.notesService.NoteDetails | APITypes.notesService.NoteListItem,
): ChipSetChip[] {
    const getSourceText = () => {
        if (note.entityType === 'user') return intl('user');
        if (note.entityType === 'medical-profile') return intl('profile');
        if (note.entityType === 'care-team-member') return intl('careTeamMember');
        if (note.entityType === 'medication') return intl('medications');
        if (note.entityType === 'allergy') return intl('allergies');
        if (note.entityType === 'condition') return intl('conditions');
        if (note.entityType === 'visit') return intl('visits');

        // should not be null if it gets to here
        if (note.resourceType) {
            // @ts-expect-error TS7053
            return resourceCategoryMessages[note.resourceType];
        }
    };

    // A client-record note has no source chip; a note's link to a counterpart note is a pill beside its title.
    const sourceText = getSourceText();
    return [
        ...(sourceText ? [{ title: sourceText, isMuted: false }] : []),
        ...note.tags.map((tagText) => ({
            title: noteCategoryTagMessages(tagText),
            isMuted: true,
        })),
    ];
}
